import React from 'react';
import { makeStyles } from '@material-ui/core';
import Link from '#web-components/components/Link';
import Typography from '#web-components/components/Typography';
import { ReactComponent as LogoIcon } from '#web-components/assets/icons/logo.svg';
import styles from './HomeButton.styles';

const useStyles = makeStyles(styles, { name: 'EGovNavbar' });

interface Props {
  direction: 'right' | 'left';
  fullWidth?: boolean;
  appTitle: string;
  navLinkComponent: React.ElementType;
  homePath: string;
}

const HomeButton: React.FC<Props> = (props) => {
  const {
    direction, fullWidth, appTitle, navLinkComponent, homePath,
  } = props;
  const classes = useStyles({ direction, fullWidth });

  return (
    <Link to={homePath} className={classes.logo} component={navLinkComponent}>
      {
        direction === 'left' && <LogoIcon />
      }
      <Typography variant="siteNames" className={classes.title}>
        {appTitle}
      </Typography>
      {
        direction === 'right' && <LogoIcon />
      }
    </Link>
  );
};

export default HomeButton;
